export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_REQUESTS_PENDING = "SET_REQUESTS_PENDING";
export const SET_REQUESTS_LIST = "SET_REQUESTS_LIST";
export const REQUESTS_LIST_ERROR = "REQUESTS_LIST_ERROR";